(function () {
  'use strict';

  var _toastTimer = null;
  var _fixedToastEl = null;
  var _fixedToastTimer = null;

  var TOAST_ICONS = {
    error:
      '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
    success:
      '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M8 12l2 2 4-4"/></svg>',
    info:
      '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
    warn:
      '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>'
  };

  var FIXED_ICONS = {
    error:
      '<svg viewBox="0 0 20 20" fill="none" stroke="#ef4444" stroke-width="1.5" class="dd-toast__icon"><circle cx="10" cy="10" r="8"/><path d="M10 6v4m0 3h.01"/></svg>',
    success:
      '<svg viewBox="0 0 20 20" fill="none" stroke="#22c55e" stroke-width="1.5" class="dd-toast__icon"><circle cx="10" cy="10" r="8"/><path d="M7 10l2 2 4-4"/></svg>',
    info: '<svg viewBox="0 0 20 20" fill="none" stroke="#3b82f6" stroke-width="1.5" class="dd-toast__icon"><circle cx="10" cy="10" r="8"/><path d="M10 9v4m0-6h.01"/></svg>',
    warn: '<svg viewBox="0 0 20 20" fill="none" stroke="#f59e0b" stroke-width="1.5" class="dd-toast__icon"><path d="M10 3L1.5 17h17L10 3z"/><path d="M10 8v4m0 2h.01"/></svg>'
  };

  function isCartPagePath() {
    var p = (window.location.pathname || '').replace(/\/+$/, '');
    return /\/cart$/.test(p);
  }

  function resolveCartToastHost() {
    var drawer = document.querySelector('cart-drawer');
    var drawerHost = document.querySelector('#CartDrawer [data-dd-cart-toast]');
    var pageHost = document.querySelector('#main-cart-footer [data-dd-cart-toast]');
    if (drawer && drawer.classList.contains('active') && drawerHost) return drawerHost;
    if (isCartPagePath() && pageHost) return pageHost;
    return null;
  }

  function hideInlineToast(host) {
    if (!host) return;
    host.classList.remove('is--visible', 'is--error', 'is--success', 'is--info', 'is--warn');
    var msgEl = host.querySelector('[data-dd-cart-toast-msg]');
    if (msgEl) msgEl.textContent = '';
    var iconEl = host.querySelector('[data-dd-cart-toast-icon]');
    if (iconEl) iconEl.innerHTML = '';
  }

  function showInlineToast(host, message, type, duration) {
    hideInlineToast(host);
    clearTimeout(_toastTimer);
    var msgEl = host.querySelector('[data-dd-cart-toast-msg]');
    var iconEl = host.querySelector('[data-dd-cart-toast-icon]');
    if (msgEl) msgEl.textContent = message;
    if (iconEl) iconEl.innerHTML = TOAST_ICONS[type] || TOAST_ICONS.info;
    host.classList.add('is--' + type);
    void host.offsetWidth;
    host.classList.add('is--visible');
    _toastTimer = setTimeout(function () {
      hideInlineToast(host);
    }, duration);
  }

  function dismissFixedToast() {
    if (!_fixedToastEl) return;
    _fixedToastEl.classList.remove('is--visible');
    var el = _fixedToastEl;
    setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, 350);
    _fixedToastEl = null;
    clearTimeout(_fixedToastTimer);
    _fixedToastTimer = null;
  }

  function showFixedCompactToast(message, type, duration) {
    dismissFixedToast();
    type = type || 'info';
    duration = duration || 4000;
    var safeMessage = String(message || '');
    var el = document.createElement('div');
    el.className = 'dd-toast-fallback is--' + type;
    el.style.setProperty('--dd-toast-dur', duration + 'ms');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      (FIXED_ICONS[type] || FIXED_ICONS.info) +
      '<span class="dd-toast-fallback__msg"></span>' +
      '<button type="button" class="dd-toast-fallback__close" aria-label="Dismiss">&times;</button>' +
      '<span class="dd-toast-fallback__bar"></span>';
    var msgEl = el.querySelector('.dd-toast-fallback__msg');
    if (msgEl) msgEl.textContent = safeMessage;
    document.body.appendChild(el);
    el.querySelector('.dd-toast-fallback__close').addEventListener('click', dismissFixedToast);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('is--visible');
      });
    });
    _fixedToastEl = el;
    _fixedToastTimer = setTimeout(dismissFixedToast, duration);
  }

  function ddToast(msg, opts, durationLegacy) {
    var message = String(msg || '').trim();
    if (!message) return null;

    var type = 'info';
    var duration = 4000;

    if (typeof opts === 'number' && durationLegacy === undefined) {
      duration = opts;
      opts = {};
    } else if (typeof opts === 'string') {
      type = opts;
      if (typeof durationLegacy === 'number') duration = durationLegacy;
      opts = {};
    } else {
      opts = opts || {};
      type = opts.type || opts.level || 'info';
      duration = opts.duration || 4000;
    }

    if (type !== 'error' && type !== 'success' && type !== 'info' && type !== 'warn') type = 'info';

    var host = resolveCartToastHost();
    if (host) {
      showInlineToast(host, message, type, duration);
      return host;
    }

    showFixedCompactToast(message, type, duration);
    return _fixedToastEl;
  }

  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-dd-cart-toast-close]');
    if (!close) return;
    var host = close.closest('[data-dd-cart-toast]');
    if (host) {
      clearTimeout(_toastTimer);
      hideInlineToast(host);
    }
  });

  window._ddCartToast = {
    ddToast: ddToast,
    showInlineToast: showInlineToast,
    showFixedCompactToast: showFixedCompactToast,
    dismissFixedToast: dismissFixedToast
  };
  window.ddToast = ddToast;
})();
